import ufeApi from 'services/api/ufeApi';
import Empty from 'constants/empty';
import { getOrCreateAbTestUuid } from 'utils/localStorage/AbTestUuid';

const path = '/gway/v1/abtest-service/personalization/recap/anonymous';

function normalizeRtcoRow(row) {
    if (!row) {
        return null;
    }

    const p13n = row.p13n;

    if (!p13n) {
        return null;
    }

    const isRecapEnabled = (p13n.isRecapEnabled ?? p13n.isRecap) === true;

    return {
        context: p13n.context ?? row.context,
        deviceId: p13n.deviceId,
        abTestId: p13n.abTestId,
        endDate: p13n.abTestEndDate ?? p13n.endDate,
        isControl: p13n.isControl === true,
        isAbTest: p13n.isAbTest === true,
        isRecap: isRecapEnabled
    };
}

function getP13nRecapABTestData(token, {
    channel, country, language, contextId, abTestEndDate
}) {
    // Generate or retrieve persistent Session-ID (UUID) for this AB test context
    // UFE uses Session-ID, mobile apps use Device-ID
    // This ensures consistent bucketing for the anonymous user across sessions
    const sessionId = getOrCreateAbTestUuid(contextId, abTestEndDate);

    if (!sessionId) {
        Sephora.logger.error('PUWYLO RTCO RECAP: Failed to generate session ID for AB test');

        return Promise.resolve(null);
    }

    const locale = `${language}-${country}`;
    // API expects "deviceId" parameter but UFE sends Session-ID value
    const queryParams = `?deviceId=${encodeURIComponent(sessionId)}&contextId=${encodeURIComponent(contextId)}&channel=${encodeURIComponent(channel)}&locale=${encodeURIComponent(locale)}`;

    const url = `${path}${queryParams}`;

    return ufeApi
        .makeRequest(url, {
            method: 'GET',
            excludeSephTokens: true,
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
        .then(({ data = Empty.Array, errorCode, message, status }) => {
            // Check for API-level errors (errorCode from ufeApi)
            if (errorCode) {
                Sephora.logger.warn(`PUWYLO RTCO RECAP: API error - ${message || 'Unknown error'}`);

                return Promise.reject(data);
            }

            // Check for business-level errors from AbTest Service
            // status: 0 = success, status: 1 = error
            if (status !== 0) {
                Sephora.logger.warn(`PUWYLO RTCO RECAP: AbTest Service error (status ${status}) - ${message || 'Unknown error'}`);

                return null;
            }

            // Extract first data row from response array
            const firstRow = Array.isArray(data) ? data[0] : data;

            if (!firstRow) {
                Sephora.logger.warn('PUWYLO RTCO RECAP: No data returned from AbTest Service');

                return null;
            }

            return normalizeRtcoRow(firstRow);
        })
        .catch(error => {
            Sephora.logger.error('PUWYLO RTCO RECAP: Failed to fetch data', error);

            return null;
        });
}

export default getP13nRecapABTestData;
